import CoverageAccordion from "@/components/domains/CoverageAccordion";
import CoverageSection from "@/components/domains/CoverageSection";
import JourneysSection from "@/components/domains/JourneysSection";
import LoadingCoverageSection from "@/components/domains/LoadingCoverageSection";
import type {
  DomainJourneys,
  DomainPage,
  DomainTestUser,
  IndexPagination as IndexPaginationData,
  JourneyRow,
  SubscriptionTier,
} from "@/types";

type Props = {
  exploring: boolean;
  domainId: string;
  journeys: DomainJourneys;
  pagesExpanded: boolean;
  pages: DomainPage[];
  pagesPagination: IndexPaginationData;
  buildPagesHref: (page: number) => string;
  evaluating: boolean;
  plan: SubscriptionTier;
  auditsUsed: number;
  auditsRemaining: number;
  auditLimit: number;
  auditsRefreshAt: string | null;
  canStartAudits: boolean;
  testUser?: DomainTestUser;
  onWatchLive: (page: DomainPage) => void;
  onWatchPage: (page: DomainPage) => void;
  onWatchMapping?: (interactionId: string) => void;
  onWatchJourney?: (journey: JourneyRow) => void;
};

export default function DomainCoverageAccordion({
  exploring,
  domainId,
  journeys,
  pagesExpanded,
  pages,
  pagesPagination,
  buildPagesHref,
  evaluating,
  plan,
  auditsUsed,
  auditsRemaining,
  auditLimit,
  auditsRefreshAt,
  canStartAudits,
  testUser,
  onWatchLive,
  onWatchPage,
  onWatchMapping,
  onWatchJourney,
}: Props) {
  return (
    <CoverageAccordion
      journeysExpanded={journeys.expanded}
      pagesExpanded={pagesExpanded}
      journeys={(panel) => (
        <JourneysSection
          domainId={domainId}
          journeys={journeys}
          plan={plan}
          auditsUsed={auditsUsed}
          auditsRemaining={auditsRemaining}
          auditLimit={auditLimit}
          auditsRefreshAt={auditsRefreshAt}
          canStartAudits={canStartAudits}
          testUser={testUser}
          expanded={panel.expanded}
          onToggle={panel.onToggle}
          onWatchMapping={onWatchMapping}
          onWatchJourney={onWatchJourney}
        />
      )}
      pages={(panel) =>
        exploring ? (
          <LoadingCoverageSection expanded={panel.expanded} onToggle={panel.onToggle} />
        ) : (
          <CoverageSection
            domainId={domainId}
            pages={pages}
            summary={{ evaluating }}
            paging={{ pagination: pagesPagination, buildPageHref: buildPagesHref }}
            plan={plan}
            auditsUsed={auditsUsed}
            auditsRemaining={auditsRemaining}
            auditLimit={auditLimit}
            auditsRefreshAt={auditsRefreshAt}
            canStartAudits={canStartAudits}
            expanded={panel.expanded}
            onToggle={panel.onToggle}
            onWatchLive={onWatchLive}
            onWatchPage={onWatchPage}
          />
        )
      }
    />
  );
}
